import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const CZ: DeepPartial<Payments> = {
    useGroupSpecToRenderBadge: {
        enabled: true,
    },
    useFocusPageSaveForLaterSnackbarFormReset: {
        enabled: true,
    },
};
